import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import cx from 'classnames';
export const ErrorBanner = ({ heading, children, variant = 'error', buttonsSlot = '', buttonProp = null, secondButtonProp = null, dismissible = false, isDismissed = false, addIcon = false, buttonsAlignment = 'row', onClose }) => {
    const { buttonText, ...restProps } = buttonProp ?? {};
    const { buttonText: secondButtonText, ...secondRestProps } = secondButtonProp ?? {};
    const iconPerVariant = {
        success: _jsx(CatIconSuccess, { slot: "before" }),
        warning: _jsx(CatIconWarningTriangle, { slot: "before" }),
        error: _jsx(CatIconWarningCircle, { slot: "before" }),
        info: _jsx(CatIconInfo, { slot: "before" })
    };
    const hasAfterSlot = buttonsSlot === 'after' || buttonProp?.slot === 'after';
    const buttons = buttonProp || secondButtonProp ? (_jsxs("div", { className: cx({
            'd-flex': buttonsAlignment === 'row',
            'pt-3': !hasAfterSlot
        }), ...(hasAfterSlot && { slot: 'after' }), children: [buttonProp ? _jsx(CatButton, { ...restProps, children: buttonText }) : null, secondButtonProp ? (_jsx(CatButton, { ...secondRestProps, children: secondButtonText })) : null] })) : null;
    const handleNotificationClose = useCallback(() => {
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    return (_jsxs(CatInlineNotification, { heading: heading, variant: variant === 'info' ? undefined : variant, dismissible: dismissible, isDismissed: isDismissed, onBlInlineNotificationClose: handleNotificationClose, "data-testid": 'cat-inline-notification', children: [addIcon && iconPerVariant[variant], children, buttons] }));
};
